<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('video_galleries.video')">
              <data-table :edit-item="editItem" />
            </b-tab>
            <b-tab :title="$t('site.add')" @click="newItem = {}">
              <my-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "VideoIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
    };
  },
  methods: {
    title() {},
    editItem(data) {
      delete data.item.image;
      this.newItem = data.item;
      this.tab = 1;
    },
  },
};
</script>
